export const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;

function getBackendUrl(): string {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  if (typeof window !== 'undefined') {
    return `http://${window.location.hostname}:3000`;
  }
  return 'http://localhost:3000';
}

export const backend_url = getBackendUrl();

export const appleClientId = process.env.REACT_APP_APPLE_CLIENT_ID;
export const appleRedirectUri = process.env.REACT_APP_APPLE_REDIRECT_URI;
